// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-codeflask[data-v-5dcecbfe]{position:relative;width:100%}.codeflask pre[data-v-5dcecbfe]{color:#000;background-color:transparent;border:unset;border-radius:unset}.codeflask__textarea[data-v-5dcecbfe]{border:1px solid #eee}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
